import React, { Fragment, useContext, useState, useEffect, useRef } from 'react';
// import { useTranslation } from 'react-i18next'

import {
  Box,
  Stack,
  Center,
  useColorModeValue,
  SimpleGrid,
  TagRightIcon,
  TagLeftIcon,
  Heading,
  Wrap,
  WrapItem,
  Text,
  useDisclosure,
  Link,
  Image,
  useColorMode,
  VStack,
  Flex,
  HStack,
  Grid,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from '@chakra-ui/react';

import { GrAnnounce } from 'react-icons/gr';
import { FaGraduationCap, FaTrophy } from 'react-icons/fa';
import { MdAccountCircle } from 'react-icons/md';
import { IoMdChatboxes } from 'react-icons/io';
import { useQuery } from '@apollo/client';
import subjectQuery from '../graphql/queries/subjects_public_alive';
// add announces query
import getAnnouncesQuery from '../graphql/queries/getAnnounces';
// add courses query
import coursesQuery from '../graphql/queries/courses';
import SubjectLayout from '../components/layouts/SubjectLayout';
import CourseCard from '../components/pages/HomePage/CourseCard';
import AuthContext from '../contexts/AuthContext';
import SubjectLayoutSkeleton from '../components/skeleton/SubjectLayoutSkeleton';
// add i18n
import { useTranslation } from 'react-i18next';
import { LinkifyText } from '../lib/LinkifyText';
import { GrPrevious, GrNext } from 'react-icons/gr';
import Slider from 'react-slick';

const HomePage = () => {
  const { user } = useContext(AuthContext);
  const { data: subjectsData, loading, refetch } = useQuery(subjectQuery, { fetchPolicy: 'network-only' });
  // fetch announces
  const { data: announcesData } = useQuery(getAnnouncesQuery);
  // fetch courses
  const { data: coursesData, loading: coursesLoading } = useQuery(coursesQuery, { fetchPolicy: 'network-only' });
  console.log('🚀 ~ HomePage ~ announcesData:', announcesData);

  const [subjectsState, setSubjectsState] = useState([]);
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  // disclosure for announce popup
  const { isOpen: announceOpen, onOpen: openAnnounce, onClose: closeAnnounce } = useDisclosure();
  // i18n
  const { t } = useTranslation();

  const [curItems, setCurItems] = useState([]);

  const itemLimit = 4;

  const [pagesQuantity, setPagesQuantity] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [, setCourseSubjectSlide] = useState({});
  const courseSubjectSliderRefs = useRef({});

  const prevSlide = () => {
    setCurrentSlide((s) => (s === 0 ? slidesCount - 1 : s - 1));
  };

  const nextSlide = () => {
    setCurrentSlide((s) => (s === slidesCount - 1 ? 0 : s + 1));
  };

  const setSlide = (slide) => {
    setCurrentSlide(slide);
  };

  const getCourseSubjects = (course) =>
    [...(course?.courseItems || [])]
      .sort((a, b) => (a.index || 0) - (b.index || 0))
      .map((item) => item.subject)
      .filter(Boolean);

  const moveCourseSubjectSlide = (courseId, total, direction) => {
    if (!total) return;
    const slider = courseSubjectSliderRefs.current[courseId];
    if (slider) {
      direction === 'next' ? slider.slickNext() : slider.slickPrev();
      return;
    }

    setCourseSubjectSlide((state) => {
      const current = state[courseId] || 0;
      const next = direction === 'next' ? (current + 1) % total : (current - 1 + total) % total;
      return { ...state, [courseId]: next };
    });
  };

  const getCourseSubjectSliderSettings = (courseId, total) => ({
    dots: total > 1,
    arrows: false,
    infinite: total > 3,
    speed: 500,
    slidesToShow: Math.min(total || 1, 3),
    slidesToScroll: 1,
    beforeChange: (_, next) => {
      setCourseSubjectSlide((state) => ({ ...state, [courseId]: next }));
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(total || 1, 2),
          infinite: total > 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: total > 1,
        },
      },
    ],
  });

  useEffect(() => {
    if (Array.isArray(subjectsData?.subjects)) {
      const pagesTotal = Math.ceil(subjectsData.subjects.length / itemLimit);
      setPagesQuantity(pagesTotal);

      setSubjectsState(subjectsData.subjects.slice(0, 8));
    } else {
      setSubjectsState([]);
    }
  }, [subjectsData]);

  const arrowStyles = {
    cursor: 'pointer',
    pos: 'absolute',
    top: '50%',
    w: 'auto',
    mt: '-22px',
    p: '16px',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
    transition: '0.6s ease',
    borderRadius: '0 3px 3px 0',
    userSelect: 'none',
    _hover: {
      opacity: 0.8,
      bg: 'black',
    },
  };

  const slides = [
    // {
    //   img: './images/intro_image3.jpg',
    //   label: '',
    //   description: '',
    // },
    {
      img: './images/homepage.png',
      label: '',
      description: '',
    },
    {
      img: './images/gif2.gif',
      label: '',
      description: '',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesCount = slides.length;
  // state for announce view
  const [announceViewData, setAnnounceViewData] = useState(null);
  // list of active announces and current index
  const [activeAnnounces, setActiveAnnounces] = useState([]);
  const [announceIdx, setAnnounceIdx] = useState(0);
  console.log('🚀 ~ HomePage ~ announceViewData:', announceViewData);

  // helper to format datetime text
  const fmtDateTime = (iso) => {
    try {
      if (!iso) return '';
      return new Date(iso).toLocaleString();
    } catch {
      return '';
    }
  };

  // open popup with all active announces (within time range)
  useEffect(() => {
    console.log('🚀 ~ HomePage ~ announcesData:', announcesData);
    if (announcesData?.announces?.length) {
      const now = Date.now();
      const active = announcesData.announces.filter((a) => {
        const s = a?.startDate ? new Date(a.startDate).getTime() : -Infinity;
        const e = a?.endDate ? new Date(a.endDate).getTime() : Infinity;
        return s <= now && now <= e;
      });
      if (active.length) {
        setActiveAnnounces(active);
        setAnnounceIdx(0);
        setAnnounceViewData(active[0]);
        openAnnounce();
      }
    }
  }, [announcesData, openAnnounce]);

  // sync current view when index changes
  useEffect(() => {
    if (activeAnnounces.length) setAnnounceViewData(activeAnnounces[announceIdx]);
  }, [activeAnnounces, announceIdx]);

  const nextAnnounce = () => {
    if (!activeAnnounces.length) return;
    setAnnounceIdx((i) => (i + 1) % activeAnnounces.length);
  };
  const prevAnnounce = () => {
    if (!activeAnnounces.length) return;
    setAnnounceIdx((i) => (i - 1 + activeAnnounces.length) % activeAnnounces.length);
  };

  const carouselStyle = {
    transition: 'all .5s',
    ml: `-${currentSlide * 100}%`,
    background: `linear - gradient(rgba(255, 0, 150, 0.3), rgba(255, 0, 150, 0.3))`,
  };

  const SLIDES_INTERVAL_TIME = 6000;
  const ANIMATION_DIRECTION = 'right';
  useEffect(() => {
    const prevSlide = () => {
      setCurrentSlide((s) => (s === 0 ? slidesCount - 1 : s - 1));
    };

    const nextSlide = () => {
      setCurrentSlide((s) => (s === slidesCount - 1 ? 0 : s + 1));
    };

    const automatedSlide = setInterval(() => {
      ANIMATION_DIRECTION.toLowerCase() === 'left' ? prevSlide() : nextSlide();
    }, SLIDES_INTERVAL_TIME);
    return () => clearInterval(automatedSlide);
  }, [slidesCount]);

  return (
    <Fragment>
      <Modal isOpen={announceOpen} onClose={closeAnnounce} size='lg' isCentered>
        <ModalOverlay />
        <ModalContent maxW='8xl' h='600px'>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Grid templateColumns='1fr 1fr' h='full'>
              {/* ซ้าย - รูปภาพ */}
              <Box>
                {announceViewData?.image ? (
                  <Image
                    w='100%'
                    h='100%'
                    objectFit='cover'
                    src={announceViewData.image}
                    alt='announce'
                    borderLeftRadius='md'
                  />
                ) : (
                  <Center w='100%' h='100%' bg='gray.200' borderLeftRadius='md'>
                    <GrAnnounce size='80px' />
                  </Center>
                )}
              </Box>

              {/* ขวา - ข้อความ */}
              <Box p={6} overflowY='auto'>
                <Text fontSize='2xl' fontWeight='bold' mb={4} pb={2} borderBottom='2px solid' borderColor='blue.500'>
                  {announceViewData?.title || t('announcePopup.title')}
                </Text>

                <Text whiteSpace='pre-wrap' fontSize='md'>
                  {LinkifyText({ text: announceViewData?.content || '' }) || ''}
                </Text>
              </Box>
            </Grid>
          </ModalBody>

          <ModalFooter>
            <Stack w='full' spacing={3}>
              <HStack w='full' justify='space-between'>
                <Button onClick={prevAnnounce} isDisabled={!activeAnnounces.length} leftIcon={<GrPrevious />} />

                <HStack spacing={1}>
                  {activeAnnounces.map((_, idx) => (
                    <Box
                      key={idx}
                      boxSize='8px'
                      rounded='full'
                      bg={idx === announceIdx ? 'blue.500' : 'gray.300'}
                      cursor='pointer'
                      onClick={() => setAnnounceIdx(idx)}
                    />
                  ))}
                </HStack>

                <Button
                  colorScheme='blue'
                  onClick={nextAnnounce}
                  isDisabled={!activeAnnounces.length}
                  leftIcon={<GrNext />}
                />
              </HStack>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <VStack spacing={'0'} align={'stretch'} width={'100%'} height={'100%'}>
        <Flex w='full' overflow='hidden'>
          <Flex pos='relative' h={['250px', '500px', '500px', '650px']} w='full' {...carouselStyle}>
            {slides.map((slide, sid) => (
              <Box key={`slide-${sid}`} flex='none' boxSize='full' shadow='md'>
                <Text mt={'2'} color='white' fontSize='xs' p='8px 12px' pos='absolute' top='0' whiteSpace='nowrap'>
                  {sid + 1} / {slidesCount}
                </Text>
                <Image objectFit={'fill'} src={slide?.img} alt='carousel image' boxSize='full' backgroundSize='cover' />

                <Stack pos='absolute' bottom='10px' textAlign='center' w='full' mb='8' color='white'></Stack>
                <HStack justify='center' pos='absolute' bottom='8px' w='full'>
                  {Array.from({
                    length: slidesCount,
                  }).map((_, slide) => (
                    <Box
                      key={`dots-${slide}`}
                      cursor='pointer'
                      boxSize={['7px', null, '15px']}
                      m='0 2px'
                      bg={currentSlide === slide ? 'blackAlpha.800' : 'blackAlpha.500'}
                      rounded='50%'
                      display='inline-block'
                      transition='background-color 0.6s ease'
                      _hover={{
                        bg: 'blackAlpha.800',
                      }}
                      onClick={() => setSlide(slide)}
                    ></Box>
                  ))}
                </HStack>
              </Box>
            ))}
          </Flex>
        </Flex>

        {/* ======================== */}
        {/* Courses Section */}
        {/* ======================== */}
        {coursesData?.courses?.filter((c) => c.status === 'public').length > 0 && (
          <Box px={5} py={5}>
            <Heading
              fontSize={['25px', '20px', '30px', '30px']}
              mb={4}
              color={
                colorMode === 'light'
                  ? 'primary.900'
                  : 'rgba(255,255,255,1)'
              }
            >
              {t("course.tittle")}
            </Heading>
            {coursesLoading ? (
              <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
                {Array.from({ length: 3 }).map((_, index) => (
                  <Box key={index}>
                    <SubjectLayoutSkeleton />
                  </Box>
                ))}
              </SimpleGrid>
            ) : (
              <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
                {coursesData.courses
                  .filter((c) => c.status === 'public')
                  .map((course) => (
                    <CourseCard key={course._id} course={course} />
                  ))}
              </SimpleGrid>
            )}
          </Box>
        )}

        {/* ======================== */}
        {/* Subjects Section */}
        {/* ======================== */}
        <Box px={5} py={5} maxHeight={'200vh'}>
          <Stack
            direction={['column', '', 'row']}
            justifyContent='space-between'
            align={{ base: 'center', md: 'flex-start' }}
          >
            <Link href={'/courses'}>
              <Heading
                fontSize={['25px', '20px', '30px', '30px']}
                color={
                  colorMode === 'light'
                    ? ['primary.900', 'primary.900', 'primary.900', 'primary.900']
                    : ['rgba(255,255,255,1)', 'rgba(255,255,255,1)', 'rgba(255,255,255,1)', 'rgba(255, 255, 255, 1)']
                }
              >
                {t('homePage.openCoursesTitle')}
              </Heading>
            </Link>
          </Stack>
          <Stack spacing={6} mt={4}>
            {coursesLoading ? (
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                {Array.from({ length: 4 }).map((_, index) => (
                  <Box key={index}>
                    <SubjectLayoutSkeleton />
                  </Box>
                ))}
              </SimpleGrid>
            ) : coursesData?.courses?.filter((course) => course.status === 'public').length ? (
              coursesData.courses
                .filter((course) => course.status === 'public')
                .map((course) => {
                  const courseSubjects = getCourseSubjects(course);

                  return (
                    <Box key={course._id} borderWidth='1px' borderRadius='lg' p={5} bg={colorMode === 'light' ? 'white' : 'gray.700'} boxShadow='md'>
                      <Flex justify='space-between' align='center' mb={4}>
                        <Box>
                          <Heading as='h3' size='md' color={colorMode === 'light' ? 'primary.900' : 'white'}>
                            {course.name}
                          </Heading>
                          <Text fontSize='sm' color='gray.500'>
                            {course.description || `${courseSubjects.length} รายวิชา`}
                          </Text>
                        </Box>
                        <HStack>
                          <Button size='sm' onClick={() => moveCourseSubjectSlide(course._id, courseSubjects.length, 'prev')} isDisabled={courseSubjects.length <= 1}>
                            <GrPrevious />
                          </Button>
                          <Button size='sm' onClick={() => moveCourseSubjectSlide(course._id, courseSubjects.length, 'next')} isDisabled={courseSubjects.length <= 1}>
                            <GrNext />
                          </Button>
                        </HStack>
                      </Flex>
                      {courseSubjects.length ? (
                        <Box
                          sx={{
                            '.slick-slider': { position: 'relative', display: 'block', boxSizing: 'border-box', userSelect: 'none', touchAction: 'pan-y' },
                            '.slick-list': { position: 'relative', display: 'block', overflow: 'hidden', m: '0 -8px', p: 0 },
                            '.slick-track': { position: 'relative', top: 0, left: 0, display: 'block' },
                            '.slick-track:before, .slick-track:after': { display: 'table', content: '""' },
                            '.slick-track:after': { clear: 'both' },
                            '.slick-slide': { display: 'none', float: 'left', height: '100%', minHeight: '1px' },
                            '.slick-initialized .slick-slide': { display: 'block' },
                            '.slick-slide > div': { px: '8px' },
                            '.slick-dots': { display: 'flex !important', justifyContent: 'center', gap: '6px', listStyleType: 'none', p: 0, mt: 4, mb: 0 },
                            '.slick-dots li': { m: 0 },
                            '.slick-dots button': {
                              w: '8px',
                              h: '8px',
                              p: 0,
                              borderRadius: '999px',
                              border: '0',
                              bg: colorMode === 'light' ? 'gray.300' : 'gray.500',
                              color: 'transparent',
                              cursor: 'pointer',
                            },
                            '.slick-dots .slick-active button': { bg: 'primary.700', w: '20px' },
                          }}
                        >
                          <Slider
                            ref={(slider) => {
                              if (slider) courseSubjectSliderRefs.current[course._id] = slider;
                            }}
                            {...getCourseSubjectSliderSettings(course._id, courseSubjects.length)}
                          >
                            {courseSubjects.map((subject) => (
                              <Box key={subject._id} py={1}>
                                <Box
                                  borderWidth='1px'
                                  borderRadius='md'
                                  overflow='hidden'
                                  cursor='pointer'
                                  h='100%'
                                  bg={colorMode === 'light' ? 'white' : 'gray.800'}
                                  onClick={() => {
                                    window.location.href = `/subject/${subject._id}`;
                                  }}
                                >
                                  <Image
                                    src={
                                      subject.photo ||
                                      'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
                                    }
                                    h='140px'
                                    w='100%'
                                    objectFit='cover'
                                  />
                                  <Box p={3}>
                                    <Text fontWeight='bold' noOfLines={1}>
                                      {subject.name}
                                    </Text>
                                    <Text fontSize='sm' color='gray.500' noOfLines={2}>
                                      {subject.description || '-'}
                                    </Text>
                                  </Box>
                                </Box>
                              </Box>
                            ))}
                          </Slider>
                        </Box>
                      ) : (
                        <Text color='gray.500'>ยังไม่มีรายวิชาในคอร์สนี้</Text>
                      )}
                    </Box>
                  );
                })
            ) : (
              <Box textAlign='center' py={10} w='full'>
                <Text fontSize='2xl' color='gray.500'>
                  {t('homePage.noCourses')}
                </Text>
              </Box>
            )}
          </Stack>
        </Box>
        <Box
          bg={useColorModeValue('gray.50', 'gray.900')}
          color={useColorModeValue('primary.900', 'gray.200')}
          w={'full'}
          align={'center'}
        >
          {/* <Flex h={['250px', '500px', '500px', '600px']} w='full'>
            <Image
              objectFit={'fill'}
              src={'/images/bg2.jpg'}
              alt='carousel image'
              boxSize='full'
              backgroundSize='cover'
            />
          </Flex>
          <Flex h={['250px', '500px', '500px', '600px']} w='full'>
            <Image
              objectFit={'cover'}
              src={'/images/bg1.jpg'}
              alt='carousel image'
              boxSize='full'
              backgroundSize='cover'
            />
          </Flex> */}
          <SimpleGrid columns={{ base: 1, sm: 2, md: 2 }} spacing='80px' py={5}>
            <Stack align={{ base: 'center', md: 'flex-end' }}>
              <Center
                fontSize={{
                  base: '5vw',
                  md: '2.3vw',
                  sm: '3.5vw',
                }}
              >
                สื่อการเรียนรู้ด้วยตัวเอง
                <TagRightIcon as={MdAccountCircle} />
              </Center>
              <Center
                fontSize={{
                  base: '4vw',
                  md: '1.5vw',
                  sm: '2.7vw',
                }}
              >
                ความสะดวกสบายด้วยเข้าถึงเนื้อหาได้จากทุกที่
              </Center>
              <Center
                fontSize={{
                  base: '5vw',
                  md: '2.3vw',
                  sm: '3.5vw',
                }}
              >
                ใบรับรองอัตโนมัติ
                <TagRightIcon as={FaGraduationCap} />
              </Center>
              <Center
                fontSize={{
                  base: '4vw',
                  md: '1.5vw',
                  sm: '2.7vw',
                }}
              >
                ทดสอบและรับใบรับรองจากเราได้ทันที
              </Center>
            </Stack>
            <Stack
              align={{
                base: 'center',
                md: 'flex-start',
              }}
            >
              <Center
                fontSize={{
                  base: '5vw',
                  md: '2.3vw',
                  sm: '3.5vw',
                }}
              >
                <TagLeftIcon as={FaTrophy} />
                สร้างประวัติของคุณ
              </Center>
              <Center
                fontSize={{
                  base: '4vw',
                  md: '1.5vw',
                  sm: '2.7vw',
                }}
              >
                เวลาในการแสดงความสามารถของคุณมาถึงแล้ว
              </Center>
              <Center
                fontSize={{
                  base: '5vw',
                  md: '2.3vw',
                  sm: '3.5vw',
                }}
              >
                <TagLeftIcon as={IoMdChatboxes} />
                กระดานสนทนา
              </Center>
              <Center
                fontSize={{
                  base: '4vw',
                  md: '1.5vw',
                  sm: '2.7vw',
                }}
              >
                พื้นที่พูดคุยและแลกเปลี่ยนความรู้
              </Center>
            </Stack>
          </SimpleGrid>
        </Box>
      </VStack>
    </Fragment>
  );
};

export default HomePage;
